module.exports = __webpack_public_path__ + "static/media/supplier-is-provider.82682ac9.svg";